<div class="authenticating">
  <i class="fa fa-user-check fa-3x"></i>
  <br />
  Redirecting to login page&hellip;
</div>
